import createIcon from '../../createIcon';

/**
 * @component @name RampRight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuNSAyMUgxNC41VjYuODNMMTYuMDkgOC40MkwxNy41IDdMMTMuNSAzTDkuNSA3TDEwLjkxIDguNDFMMTIuNSA2LjgzVjlDMTIuNSAxMy4yNyA4LjQ3IDE2LjEzIDYuNSAxNy4yN0w3Ljk2IDE4LjczQzkuODcgMTcuNTYgMTEuNCAxNi4xOSAxMi41IDE0LjdWMjFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RampRight = createIcon('RampRight', [
  [
    'path',
    {
      d: 'M12.5 21H14.5V6.83L16.09 8.42L17.5 7L13.5 3L9.5 7L10.91 8.41L12.5 6.83V9C12.5 13.27 8.47 16.13 6.5 17.27L7.96 18.73C9.87 17.56 11.4 16.19 12.5 14.7V21Z',
      key: '5u2jgh',
    },
  ],
]);

export default RampRight;
